
import { tr, trVars } from '../translate'
import ExternalLink from '@/assets/icons/support_ticket/external-link.svg?inline'
import FileSearch from '@/assets/icons/support_ticket/file-search.svg?inline'

export default {
  components: { ExternalLink, FileSearch },
  props: {
    config: {
      type: Object,
      default: null,
    },
    orderUuid: {
      type: String,
      default: null,
    },
    orderNum: {
      type: String,
      default: '',
    },
  },
  computed: {
    ui() {
      return this.config?.ui
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
    trVars(entry, vars) {
      return trVars(entry, this.$i18n.locale, vars)
    },
  },
}
